module.exports = "<app-sidenav-component></app-sidenav-component>\n\n  <router-outlet></router-outlet>\n \n  <app-foot></app-foot>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main